import type { FC, ReactNode } from "react";

import * as styles from "./OfficeSignUpBackground.styles";

interface Props {
  roleType: "Practitioner" | "Clerk";
  children: ReactNode;
}

const OfficeSignUpBackground: FC<Props> = ({ roleType, children }) => {
  const renderBackgroundImage = () => {
    if (roleType === "Clerk") return styles.clerkBackground;
    if (roleType === "Practitioner") return styles.subPracBackground;
  };

  const backgroundStyles = [styles.background, renderBackgroundImage()];

  return (
    <div css={backgroundStyles} data-testid={`${roleType}-sign-up-background`}>
      {children}
    </div>
  );
};

export { OfficeSignUpBackground };
